import React, {Component} from 'react';

export class CommodityDetails extends Component{
    static defaultCommodityInputData = {"commodityName":"", "value":0,"weight":0.00};
    constructor(props){
        super(props);
        
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event){
        var nameSplitArray = event.target.name.split(".");
        
        var key = nameSplitArray[nameSplitArray.length-1];
        var value=event.target.value;
        this.props.onUpdate(this.props.id, key, value);
    }

    //TODO: Implement autocollapse of vehicle with a display that includes a summary of the entered details
    render(){
        var inputFor = this.props.inputFor;
        var nameInput = inputFor + "[" + this.props.id + "].commodityName";
        var valueInput = inputFor + "[" + this.props.id + "].value";
        var weightInput = inputFor + "[" + this.props.id + "].weight";

        return(
            // Individual vehicle details
            <div className="col-sm-12 col-md-6">
                <div className="row">
                
                    <strong>Commodity #{parseInt(this.props.id,10) + 1}</strong>

                    <div class="col-md-4 col-sm-6 mt-sm-2">
                        <label asp-for="" class="control-label">Commodity</label>                
                        <input required name={nameInput} class="form-control"
                            value={this.props.value["commodityName"]} onChange={this.handleChange}/>
                        <span asp-validation-for="" class="text-danger"></span>
                    </div>
                    <div class="col-md-3 col-sm-3 mt-sm-2">
                        <label class="control-label">Value ($)</label>
                        <input type="number" required name={valueInput} class="form-control"
                            value={this.props.value["value"]} onChange={this.handleChange}
                            min="0" defaultValue={0}/>
                        <span class="text-danger"></span>
                    </div>
                    <div class="col-md-3 col-sm-3 mt-sm-2">
                        <label class="control-label">Weight (lbs)</label>
                        <input type="number" required name={weightInput} class="form-control"
                            value={this.props.value["weight"]} onChange={this.handleChange}
                            min="0" defaultValue={0}/>
                        <span asp-validation-for="letterOfIntentInfo.commodities[i].weight" class="text-danger"></span>
                    </div>

                    <div class="col-md-1 col-sm-3 mt-sm-2">
                        <button type="button" onClick={() => this.props.onRemoveContainer(this.props.id)}
                            class="btn btn-danger btn-floating my-auto">
                            <i class="fa fa-2x fa-minus-circle"></i>
                        </button>
                    </div>
                    
                    <div class="col-12">
                        <hr/>
                    </div>
                </div>
            </div>
        )
    }
}